import { LawScope, TreeWithId } from '@livv/models';
import { Box } from '@mui/material';
import intersection from 'lodash/intersection';
import uniqBy from 'lodash/uniqBy';
import useTranslation from 'next-translate/useTranslation';
import { Dispatch, SetStateAction, FC, useState } from 'react';
import FilterGroups from './FilterGroups';
import List from './List';
import { BookFilter } from '@models/books';

export interface BooksPageProps {
    books: TreeWithId[];
}

const BooksPage: FC<BooksPageProps> = ({ books }) => {
    const { t, lang } = useTranslation('books');
    const [selectedLanguages, setSelectedLanguages] = useState<string[]>([
        lang.toLocaleUpperCase(),
    ]);
    const [selectedLawScopes, setSelectedLawScopes] = useState<LawScope[]>([]);

    const languageItems: BookFilter[] = uniqBy(
        books?.map(({ language }) => ({
            label: t(`common:language.${language}`),
            value: language,
        })),
        'value',
    );

    const lawScopeItems: BookFilter[] = Object.values(LawScope).map((lawScope) => {
        return { label: t(`common:lawScope.${lawScope}`), value: lawScope };
    });

    return (
        <Box data-test-id="books">
            <FilterGroups
                languages={{
                    items: languageItems,
                    listTitle: t('filters.language'),
                    multiple: false,
                    selected: selectedLanguages,
                    setSelected: setSelectedLanguages,
                }}
                lawScopes={{
                    items: lawScopeItems,
                    listTitle: t('filters.lawScope'),
                    multiple: false,
                    selected: selectedLawScopes,
                    setSelected: setSelectedLawScopes as Dispatch<SetStateAction<string[]>>,
                }}
            />
            <List
                books={
                    books?.filter(
                        (book) =>
                            (selectedLanguages.length === 0 ||
                                selectedLanguages.includes(book.language)) &&
                            (selectedLawScopes.length === 0 ||
                                intersection(selectedLawScopes, book.lawScopes).length > 0),
                    ) || []
                }
            />
        </Box>
    );
};

export default BooksPage;
